import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroBackground from "@/components/marketing/HeroBackground";
import { useAuth } from "@/lib/AuthContext";

export default function SectorHero({ eyebrow, headline, subtitle, stats = [] }) {
  const { isAuthenticated } = useAuth();
  const primaryTo = isAuthenticated ? "/dashboard/new-order" : "/register";

  return (
    <section className="relative pt-24 lg:pt-28 pb-7 sm:pb-9 lg:pb-12 overflow-hidden text-center">
      <HeroBackground />
      <Container className="relative">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-4">
          {eyebrow}
        </div>
        <h1 className="font-heading text-[clamp(36px,5vw,56px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-5 max-w-3xl mx-auto text-heading-gradient">
          {headline}
        </h1>
        <p className="text-[16px] lg:text-[17px] leading-[1.55] text-[#6c6c74] max-w-[560px] mx-auto mb-8">
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to={primaryTo}
            className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
            style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
            Get Started <ArrowRight className="inline w-4 h-4 ml-1" />
          </Link>
          <Link to="/contact"
            className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-dark-pill text-white whitespace-nowrap transition-colors hover:bg-[#3c3c42]">
            Talk to Our Team
          </Link>
        </div>
        {stats.length > 0 && (
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 lg:gap-8 max-w-3xl mx-auto">
            {stats.map((stat) => (
              <div key={stat.label}>
                <div className="font-heading text-2xl lg:text-3xl font-[650] text-[#1c1c20]">{stat.value}</div>
                <div className="text-xs text-[#8e8e96] mt-1 leading-tight">{stat.label}</div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}